import React from 'react'
import { Render, FieldLabel, DropZone } from "@measured/puck";
import './styles/style.css';
import Svg from '../../../common/Svg';
import { Link } from 'react-router-dom';


const reportLowerCost = {
    "content": [
        {
            "type": "ReportSection",
            "props": {
                "Heading": {
                    "title": "Lower Costs",
                    "fontWeight": "fw-700",
                    "titleFont": "fs-60"
                },
                "Description": {
                    "text": "Access all of the numbers behind the Lower Costs calculations, with the opportunity to change some numbers.",
                    "Font": "fs-22"
                },
                "Padding": {
                    "top": "pt-60",
                    "bottom": "pb-60"
                },
                "items": [
                    {
                        "uuid": "d5dc3fa9-2aca-4674-9750-b7b93af92b79",
                        "Title": "Cost of Phone Provisioning"
                    },
                    {
                        "uuid": "ef7789cf-38ca-4764-9f5c-21ac828a2135",
                        "Title": "Downtime"
                    },
                    {
                        "uuid": "6304a672-e805-44be-b30e-0eb54c42603e",
                        "Title": "IT Integrations and Workflows"
                    },
                    {
                        "uuid": "f83875dd-358a-4a20-b6bf-3b399aca35e2",
                        "Title": "Security and Compliance"
                    },
                    {
                        "uuid": "bdd30c14-6534-4a92-84e8-4a637b3bad71",
                        "Title": "Employee Retention and Engagement"
                    }
                ],
                "id": "ReportSection-e4337860-b3f5-4d1a-b4a9-5e515c8a607f"
            }
        }
    ],
    "root": {},
    "zones": {
        "ReportSection-e4337860-b3f5-4d1a-b4a9-5e515c8a607f:wizard-form-wrapper-0": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Cost of Phone Provisioning"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Average",
                        "Cell3": "With Microsoft",
                        "Cell4": "Saving with VBUC"
                    },
                    "items": [
                        {
                            "Cell1Data": "Number of office phones",
                            "Cell1isEditable": false,
                            "Cell2Data": "3",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "3",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Percentage of phone provisions per year (new hire, moves etc)",
                            "Cell2Data": "15",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "percentage",
                            "Cell3Data": "5",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "50",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total number of phone provisioning instances per year",
                            "Cell2Data": "1",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "1",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "1,800",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "IT hours per provisioning",
                            "Cell2Data": "20",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "0.2",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "60",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total annual hours spent provisioning phones",
                            "Cell2Data": "2.0",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "0.2",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Labour cost per IT hour",
                            "Cell2Data": "49.53",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "49.53",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total cost for phone provisioning",
                            "Cell2Data": "2.0",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "10",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total phone provisioning cost savings",
                        "Cell2": "",
                        "Cell3": "",
                        "Cell4": "89"
                    },
                    "id": "ReportTable-6c73a791-d456-4573-91c7-328177857a0f"
                }
            }
        ],
        "ReportSection-e4337860-b3f5-4d1a-b4a9-5e515c8a607f:wizard-form-wrapper-1": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Downtime"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Average",
                        "Cell3": "With Microsoft",
                        "Cell4": "Saving with VBUC"
                    },
                    "items": [
                        {
                            "Cell1Data": "Number of communications downtime events per year",
                            "Cell1isEditable": false,
                            "Cell2Data": "10",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "5",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "50",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "IT hours spent per downtime event",
                            "Cell2Data": "140",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "48",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "60",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total annual IT hours spent for downtime events",
                            "Cell2Data": "1,400",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "238",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Cost per IT staff hour",
                            "Cell2Data": "49.53",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "49.53",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total cost for IT staff downtime events",
                            "Cell2Data": "69,349",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "11,789",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total Downtime IT staff cost savings",
                        "Cell2": "",
                        "Cell3": "",
                        "Cell4": "57,560"
                    },
                    "id": "ReportTable-2827954c-28e8-4d55-964c-c8562b5a6961"
                }
            }
        ],
        "ReportSection-e4337860-b3f5-4d1a-b4a9-5e515c8a607f:wizard-form-wrapper-2": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "IT Integrations and Workflows"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Average",
                        "Cell3": "With Microsoft",
                        "Cell4": "Saving with VBUC"
                    },
                    "items": [
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of integrations /workflows",
                            "Cell2Data": "20",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "3",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "20",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Cost per integration / workflow",
                            "Cell2Data": "15,000",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "11,250",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "20",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total cost of integrations / workflows",
                            "Cell2Data": "300,000",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "168,750",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total IT integration cost savings",
                        "Cell2": "",
                        "Cell4": "131,250"
                    },
                    "id": "ReportTable-799150d3-7bb7-4c43-a7d4-7c84f4be6640"
                }
            }
        ],
        "ReportSection-e4337860-b3f5-4d1a-b4a9-5e515c8a607f:wizard-form-wrapper-3": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Security and Compliance"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Average",
                        "Cell3": "With Microsoft",
                        "Cell4": "Saving with VBUC"
                    },
                    "items": [
                        {
                            "Title": "Row",
                            "Cell1Data": "Chance of data breach over the next 12 months",
                            "Cell2Data": "12.5",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "percentage",
                            "Cell3Data": "10.0",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "percentage",
                            "Cell4Data": "20",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Expected cost of data breach",
                            "Cell2Data": "3,920,000",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Annual exposure costs of data breach",
                            "Cell2Data": "300,000",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "392,000",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "98,000",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "euro"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total Security and Compliance cost savings",
                        "Cell2": "",
                        "Cell4": "98,178"
                    },
                    "id": "ReportTable-d963928f-f833-4c64-990b-17c69919f2d7"
                }
            }
        ],
        "ReportSection-e4337860-b3f5-4d1a-b4a9-5e515c8a607f:wizard-form-wrapper-4": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Employee Retention and Engagement"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Average",
                        "Cell3": "With Microsoft",
                        "Cell4": "Saving with VBUC"
                    },
                    "items": [
                        {
                            "Cell1Data": "Number of employees",
                            "Cell1isEditable": false,
                            "Cell2Data": "4",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "4",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Turnover rate",
                            "Cell2Data": "12.6",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "percentage",
                            "Cell3Data": "10.1",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "percentage",
                            "Cell4Data": "20",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of employees onboarded each year",
                            "Cell2Data": "1",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "0",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Reduction in turnover rate with remote employee enablement",
                            "Cell2Data": "13",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "percentage",
                            "Cell3Data": "13",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "percentage",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of employees replaced each year with option for remote work enabled",
                            "Cell2Data": "0",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "0",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Reduction in number of employees replaced each year due to remote work enablement",
                            "Cell2Data": "0",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "0",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Cost per replaced worker",
                            "Cell2Data": "16,798",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "16,798",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total reduction in cost to replace workers",
                            "Cell2Data": "1,101",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "2,574",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total Employee Retention and Remote Work Savings",
                        "Cell2": "",
                        "Cell3": "",
                        "Cell4": "98,178"
                    },
                    "id": "ReportTable-4bc49f4a-01d8-4de9-964f-229c0f42f514"
                }
            }
        ]
    }
}

const reportIncreaseProductivity = {
    "content": [
        {
            "type": "ReportSection",
            "props": {
                "Heading": {
                    "title": "Increase Productivity",
                    "fontWeight": "fw-700",
                    "titleFont": "fs-50"
                },
                "Description": {
                    "text": "Access all of the numbers behind the Increase Productivity calculations, with the opportunity to change some numbers.",
                    "Font": "fs-18"
                },
                "Padding": {
                    "top": "pt-60",
                    "bottom": "pb-60"
                },
                "items": [
                    {
                        "Title": "Reducing Communications Downtime"
                    },
                    {
                        "Title": "Time Lost Switching Communications Source"
                    },
                    {
                        "Title": "Time Spent Searching for Previous Communications"
                    },
                    {
                        "Title": "Time Spent Recreating / Re-requesting Information"
                    },
                    {
                        "Title": "Time waiting for responses"
                    },
                    {
                        "Title": "Cost of interruptions"
                    },
                    {
                        "Title": "Employee time resolving issues"
                    }
                ],
                "id": "ReportSection-08811fa5-306e-4065-a7a9-a5818f60252d"
            }
        }
    ],
    "root": {},
    "zones": {
        "ReportSection-08811fa5-306e-4065-a7a9-a5818f60252d:wizard-form-wrapper-0": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Reducing Communications Downtime"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Average",
                        "Cell3": "With Microsoft",
                        "Cell4": "Saving with VBUC"
                    },
                    "items": [
                        {
                            "Cell1Data": "Total number of employees",
                            "Cell1isEditable": false,
                            "Cell2Data": "3",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "3",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of hours per year that communications are down/impacted",
                            "Cell2Data": "15",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "percentage",
                            "Cell3Data": "0.5",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "50",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Burdened hourly cost for office worker",
                            "Cell2Data": "32.00",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "32.00",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total value of time lost due to communications downtime",
                            "Cell2Data": "128",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "64",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total Communications Downtime Savings",
                        "Cell2": "",
                        "Cell3": "",
                        "Cell4": "64"
                    },
                    "id": "ReportTable-2a5ce640-8661-4b13-ad28-f4cc7aa0762e"
                }
            }
        ],
        "ReportSection-08811fa5-306e-4065-a7a9-a5818f60252d:wizard-form-wrapper-1": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Time Lost Switching Communications Source"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Average",
                        "Cell3": "With Microsoft",
                        "Cell4": "Saving with VBUC"
                    },
                    "items": [
                        {
                            "Cell1Data": "Number of different communication apps/devices per employee",
                            "Cell1isEditable": false,
                            "Cell2Data": "4",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "2",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "60",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of times per day that employees must switch focus between communications devices",
                            "Cell2Data": "20",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "16",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "20",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Average time lost switching between devices (minutes per interruption)",
                            "Cell2Data": "2.4",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "2.4",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of minutes per day lost per empoyee",
                            "Cell2Data": "48",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "38",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of employees",
                            "Cell2Data": "4",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "4",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total number of minutes lost per day for all employees",
                            "Cell2Data": "192",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "152",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total number of hours lost per year for all employees",
                            "Cell2Data": "720",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "570",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Cost per hour for office worker",
                            "Cell2Data": "32.00",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "32.00",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total number of hours lost per year for all employees",
                            "Cell2Data": "23,040",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "18,240",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total Time Lost Switching Communications Source Savings",
                        "Cell2": "",
                        "Cell3": "",
                        "Cell4": "4,800"
                    },
                    "id": "ReportTable-b1d199fd-8a54-43cf-b669-5a254e89e40e"
                }
            }
        ],
        "ReportSection-08811fa5-306e-4065-a7a9-a5818f60252d:wizard-form-wrapper-2": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Time Spent Searching for Previous Communications"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Average",
                        "Cell3": "With Microsoft",
                        "Cell4": "Saving with VBUC"
                    },
                    "items": [
                        {
                            "Cell1Data": "Number of times employees search for previous communications per day",
                            "Cell2Data": "3",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "3",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Time spend per search (minutes)",
                            "Cell2Data": "2.0",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "0.5",
                            "Cell3isEditable": true,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "75",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of minutes lost per day per employee",
                            "Cell2Data": "6.0",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "1.5",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of employees",
                            "Cell2Data": "4",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "4",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total number of minutes lost per day for all employees",
                            "Cell2Data": "24",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "6",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total number of hours lost per year for all employees",
                            "Cell2Data": "90",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "23",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Cost per hour for office worker",
                            "Cell2Data": "32.00",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "32.00",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total value of time lost searching for previous communications",
                            "Cell2Data": "2,880",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "720",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "75",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "percentage"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total Time Spent Searching for Previous Communications Savings",
                        "Cell2": "",
                        "Cell3": "",
                        "Cell4": "2,160"
                    },
                    "id": "ReportTable-d1e2c3b4-f5a6-7890-g1h2-i3j4k5l6m7n8"
                }
            }
        ],
        "ReportSection-08811fa5-306e-4065-a7a9-a5818f60252d:wizard-form-wrapper-3": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Time Spent Recreating / Re-requesting Information"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Average",
                        "Cell3": "With Microsoft",
                        "Cell4": "Saving with VBUC"
                    },
                    "items": [
                        {
                            "Cell1Data": "Percentage of times that a search for information doesn't find the desired information",
                            "Cell2Data": "10",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "percentage",
                            "Cell3Data": "3",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "percentage",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of times per year that information is recreated / re-requested (all employees)",
                            "Cell2Data": "270",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "81",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "70",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Time spent per instance recreating / re-requesting information (minutes)",
                            "Cell2Data": "6",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "6",
                            "Cell3isEditable": true,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total number of hours lost per year for all employees",
                            "Cell2Data": "27",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "8",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Cost per hour for office worker",
                            "Cell2Data": "32.00",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "32.00",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total value of time lost switching between communication devices",
                            "Cell2Data": "864",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "259",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total Time Spent Recreating / Re-requesting Information Savings",
                        "Cell2": "",
                        "Cell3": "",
                        "Cell4": "605"
                    },
                    "id": "ReportTable-d1e2c3b4-f5a6-7890-g1h2-i3j4k5l6m7n1"
                }
            }
        ],
        "ReportSection-08811fa5-306e-4065-a7a9-a5818f60252d:wizard-form-wrapper-4": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Time waiting for responses"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Average",
                        "Cell3": "With Microsoft",
                        "Cell4": "Saving with VBUC"
                    },
                    "items": [
                        {
                            "Cell1Data": "Number of different communication apps / devices per employee",
                            "Cell2Data": "4",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "4",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of times per day that employees must switch focus between communication devices",
                            "Cell2Data": "6",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "2.5",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "70",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Average time lost switching between devices (minutes per interruption)",
                            "Cell2Data": "27",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "10",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of minutes per day lost per employee",
                            "Cell2Data": "20",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "8",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of employees",
                            "Cell2Data": "4",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "4",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total number of hours lost per day for all employees",
                            "Cell2Data": "300",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "150",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Cost per hour for office worker",
                            "Cell2Data": "32.00",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "32.00",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total value of time lost searching for previous communications",
                            "Cell2Data": "9,600",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "4,800",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total Time Waiting for Responses Savings",
                        "Cell2": "",
                        "Cell3": "",
                        "Cell4": "4,800"
                    },
                    "id": "ReportTable-d1e2c3b4-f5a6-7890-g1h2-i3j4k5l6m7n3"
                }
            }
        ],
        "ReportSection-08811fa5-306e-4065-a7a9-a5818f60252d:wizard-form-wrapper-5": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Cost of interruptions"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Average",
                        "Cell3": "With Microsoft",
                        "Cell4": "Saving with VBUC"
                    },
                    "items": [
                        {
                            "Cell1Data": "Number of times that an interruption in communications source causes a change in focus per day",
                            "Cell2Data": "10",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "3",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of minutes per interruption needed to get back to the point before the distraction",
                            "Cell2Data": "25",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "25",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "70",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total minutes per person per day of productivity lost due to interruptions in communication source",
                            "Cell2Data": "250",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "75",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of employees",
                            "Cell2Data": "4",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "4",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total number of hours lost per year or all employees",
                            "Cell2Data": "3,750",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "1,125",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Cost per hour for office worker",
                            "Cell2Data": "32.00",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "32.00",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total value of reducing cost of interruptions",
                            "Cell2Data": "120,000",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "36,000",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total Cost of Interruptions savings",
                        "Cell2": "",
                        "Cell3": "",
                        "Cell4": "84,000"
                    },
                    "id": "ReportTable-d1e2c3b4-f5a6-7890-g1h2-i3j4k5l6m7n6"
                }
            }
        ],
        "ReportSection-08811fa5-306e-4065-a7a9-a5818f60252d:wizard-form-wrapper-6": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Employee time resolving issues"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Average",
                        "Cell3": "With Microsoft",
                        "Cell4": "Saving with VBUC"
                    },
                    "items": [
                        {
                            "Cell1Data": "Number of times per year that employee calls contact center for help",
                            "Cell2Data": "12",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "9",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "30",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Average number of minutes per contact",
                            "Cell2Data": "18",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "11",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "40",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of employees",
                            "Cell2Data": "4",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "4",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of hours per year spent on help searches",
                            "Cell2Data": "14",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "7",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Cost per hour per worker",
                            "Cell2Data": "32.00",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "32.00",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total cost of employee time spent on help searches",
                            "Cell2Data": "461",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "211",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total Time spend resolving issues savings",
                        "Cell2": "",
                        "Cell3": "",
                        "Cell4": "250"
                    },
                    "id": "ReportTable-d1e2c3b4-f5a6-7890-g1h2-i3j4k5l6n7n8"
                }
            }
        ]
    }
}

const reportEnableBusiness = {
    "content": [
        {
            "type": "Section",
            "props": {
                "Heading": {
                    "title": "Enable Business ",
                    "fontWeight": "fw-700",
                    "titleFont": "fs-50"
                },
                "Description": {
                    "text": "Access all of the numbers behind the Enable Business calculations, with the opportunity to change some numbers.",
                    "Font": "fs-18"
                },
                "Padding": {
                    "top": "pt-60",
                    "bottom": "pb-60"
                },
                "items": [
                    {
                        "Title": "Recovering Lost Sales Opportunities"
                    },
                    {
                        "Title": "Customer Churn"
                    },
                    {
                        "Title": "Increased Customer Satisfaction / Advocacy"
                    },
                    {
                        "Title": "Revenue boost through more effective communication with Vodafone Business UC"
                    }
                ],
                "id": "Section-f0234bdf-be82-4fe4-983a-32f2b0708be4"
            }
        }
    ],
    "root": {},
    "zones": {

        "Section-f0234bdf-be82-4fe4-983a-32f2b0708be4:wizard-form-wrapper-0": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Recovering Lost Sales Opportunities"
                    },
                    "Table": {
                        "Rows": 3,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Current",
                        "Cell3": "With Vodafone",
                        "Cell4": "Saving with Vodafone"
                    },
                    "items": [
                        {
                            "Cell1Data": "Lost opportunities due to employee / agent inefficiency (annual)",
                            "Cell2Data": "140",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "3",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "100",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Value of each lost opportunity",
                            "Cell2Data": "3,000",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "3,000",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total value of unrealised sales",
                            "Cell2Data": "450,000",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "0",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total Communications Downtime Savings",
                        "Cell2": "450,000"
                    },
                    "id": "ReportTable-d1e2c3b4-f5a6-7890-g1h2-i3j4k5k6m7n8"
                }
            }
        ],
        "Section-f0234bdf-be82-4fe4-983a-32f2b0708be4:wizard-form-wrapper-1": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Customer Churn"
                    },
                    "Table": {
                        "Rows": 5,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Current",
                        "Cell3": "With Vodafone",
                        "Cell4": "Saving with Vodafone"
                    },
                    "items": [
                        {
                            "Cell1Data": "Current number of customers",
                            "Cell2Data": "1,000",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "1,000",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Annual churn rate",
                            "Cell2Data": "7.0",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "percentage",
                            "Cell3Data": "6.3",
                            "Cell3isEditable": true,
                            "Cell3EditStyle": "percentage",
                            "Cell4Data": "10",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Customers lost per year",
                            "Cell2Data": "70",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "63",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Average annual revenue per customer",
                            "Cell2Data": "600",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "600",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Gross margin",
                            "Cell2Data": "21",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "percentage",
                            "Cell3Data": "21",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "percentage",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Lost profits due to churn",
                            "Cell2Data": "8,862",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "7,976",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total annual value of reducing customer churn",
                        "Cell2": "886"
                    },
                    "id": "ReportTable-d1e2c3b4-f5a6-7890-g1h2-i3j4q5l6m7n8"
                }
            }
        ],
        "Section-f0234bdf-be82-4fe4-983a-32f2b0708be4:wizard-form-wrapper-2": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Increased Customer Satisfaction / Advocacy"
                    },
                    "Table": {
                        "Rows": 7,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Current",
                        "Cell3": "With Vodafone",
                        "Cell4": "Saving with Vodafone"
                    },
                    "items": [
                        {
                            "Cell1Data": "Percentage of customers who are advocates",
                            "Cell2Data": "5.0",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "percentage",
                            "Cell3Data": "6.7",
                            "Cell3isEditable": true,
                            "Cell3EditStyle": "percentage",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Number of customers who are advocates",
                            "Cell2Data": "50",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "67",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "10",
                            "Cell4isEditable": true,
                            "Cell4EditStyle": "percentage"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "New customers from advocate referrals or current advocates moving to other companies and recommending your product (propagation effect from advocacy)",
                            "Cell2Data": "10",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "percentage",
                            "Cell3Data": "12",
                            "Cell3isEditable": true,
                            "Cell3EditStyle": "percentage",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "New customers from advocacy",
                            "Cell2Data": "5",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "8",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "number",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Average revenue per customer",
                            "Cell2Data": "600",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "600",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total annual new revenue from advocacy",
                            "Cell2Data": "3,000",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "£4,800",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "1",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Average revenue per customer",
                            "Cell2Data": "21",
                            "Cell2isEditable": true,
                            "Cell2EditStyle": "percentage",
                            "Cell3Data": "21",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "percentage",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Total annual new revenue from advocacy",
                            "Cell2Data": "633",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "euro",
                            "Cell3Data": "1,013",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total annual value of increased customer satisfaction / advocacy",
                        "Cell2": "380"
                    },
                    "id": "ReportTable-d1e2c3b4-f5a6-7890-g1h2-i3j4k5l6m7f8"
                }
            }
        ],
        "Section-f0234bdf-be82-4fe4-983a-32f2b0708be4:wizard-form-wrapper-3": [
            {
                "type": "ReportTable",
                "props": {
                    "Heading": {
                        "title": "Revenue boost through more effective communication with Vodafone Business UC with RingCentral"
                    },
                    "Table": {
                        "Rows": 4,
                        "Columns": 4,
                        "FirstRow": true,
                        "LastRow": true
                    },
                    "ColumnSettings": {
                        "FirstColSpan": "",
                        "SecondColSpan": "135",
                        "ThirdColSpan": "140",
                        "FourthColSpan": "180",
                        "HighlightCol": "3rd"
                    },
                    "Headings": {
                        "Cell1": "",
                        "Cell2": "Current",
                        "Cell3": "With Vodafone",
                        "Cell4": "Saving with Vodafone"
                    },
                    "items": [
                        {
                            "Cell1Data": "Current revenue",
                            "Cell2Data": "",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "600,000",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Increase in revenue through more effective communications",
                            "Cell2Data": "",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "10",
                            "Cell3isEditable": true,
                            "Cell3EditStyle": "percentage",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Annual revenue increase through more effective communications",
                            "Cell2Data": "",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "60,000",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "euro",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        },
                        {
                            "Title": "Row",
                            "Cell1Data": "Gross margin",
                            "Cell2Data": "",
                            "Cell2isEditable": false,
                            "Cell2EditStyle": "number",
                            "Cell3Data": "21",
                            "Cell3isEditable": false,
                            "Cell3EditStyle": "percentage",
                            "Cell4Data": "",
                            "Cell4isEditable": false,
                            "Cell4EditStyle": "number"
                        }
                    ],
                    "Calculations": {
                        "Cell1": "Total annual value of increased customer satisfaction / advocacy",
                        "Cell2": "12,660"
                    },
                    "id": "ReportTable-d1e2c3b4-f5a6-7890-g1h2-i3j4h5l6m7n8"
                }
            }
        ]
    }
};
export default function ROIReportSingle() {
    return (
        <>
            {/* <Render config={config} data={reportLowerCost} /> */}
        </>
    )
}

